import { Menu } from 'antd';
import 'antd/es/menu/style/index';
import './index.less';

export default Menu;
